import { render, staticRenderFns } from "./DataInputOffShore.vue?vue&type=template&id=4a12d2a5"
import script from "./DataInputOffShore.vue?vue&type=script&lang=js"
export * from "./DataInputOffShore.vue?vue&type=script&lang=js"
import style0 from "./DataInputOffShore.vue?vue&type=style&index=0&id=4a12d2a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports